import React from "react";
import styles from "./ProductSkeleton.module.scss";

export const ProductSkeleton: React.FC = () => {
  return (
    <div className={styles.card}>
      <div className={styles.imageWrapper}>
        <div className={styles.imageSkeleton} />
      </div>
      <div className={styles.content}>
        <div className={styles.titleSkeleton} />
        <div className={styles.footer}>
          <div className={styles.priceSkeleton} />
          <div className={styles.buttonSkeleton} />
        </div>
      </div>
    </div>
  );
};

